import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHomeDoor"><Path d="M12 1.21191L21 8.52441V21.0004L16 21V12H8V21H10V14H14V21H10H8L3 21.0004V8.52441L12 1.21191Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeDoor;
